import { render, staticRenderFns } from "./BuySystem.vue?vue&type=template&id=c567670a&scoped=true&"
import script from "./BuySystem.vue?vue&type=script&lang=js&"
export * from "./BuySystem.vue?vue&type=script&lang=js&"
import style0 from "./BuySystem.vue?vue&type=style&index=0&id=c567670a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c567670a",
  null
  
)

export default component.exports